import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { KPMGMessageReadIcon, KPMGMessageUnreadIcon } from '../../../assets/icons';
import NotificationsService from '../../../services/notificationsService';
import FlexContainer from '../../shared/FlexContainer';
import StyledTooltip from '../../shared/Tooltip';
const StyledFlexCotainer = styled(FlexContainer) `
  cursor: pointer;
`;
const MessageIconButton = ({ notificationId, isRead }) => {
    const { t: translate } = useTranslation();
    const tooltipTitle = useMemo(() => isRead ? 'NOTIFICATIONS.ACTION.MARK_AS_UNREAD' :
        'NOTIFICATIONS.ACTION.MARK_AS_READ', [isRead]);
    return (<StyledTooltip title={translate(tooltipTitle)}>
      <StyledFlexCotainer onClick={() => NotificationsService.toggleRead(notificationId)}>
        {isRead ? <KPMGMessageReadIcon /> : <KPMGMessageUnreadIcon />}
      </StyledFlexCotainer>
    </StyledTooltip>);
};
export default MessageIconButton;
